/**
 * @desc Yung-获取审批业务key
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ApprovalBeforeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/approval/getBusinessKey`, {
      method: "GET",

      data: body,
      ...options,
    }),
  );
}
